import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Contract from "@/pages/Contract";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, duration: 1.2, smoothWheel: true }}>
      <div className="App relative">
        <div className="noise-overlay" aria-hidden="true" />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/contract" element={<Contract />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors />
      </div>
    </ReactLenis>
  );
}

export default App;
